import { BaseState } from '@/store/base-state';

export default class RepairsState extends BaseState {}
